import { Row, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import API from "../services/api-request";

const SelectClientProduct = ({ value, onChange, nullOptions, idClient }) => {
  const [listData, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getProduct = async () => {
    setLoading(true);
    API.Post(
      `dashboard/stocks?limit=1000&page=1${
        idClient ? "&client_id=" + idClient : ""
      }`
    )
      .then((res) => {
        const newData = res?.data?.data?.stock;

        const uniqueData = [
          ...new Map(newData.map((item) => [item.product_id, item])).values(),
        ];

        setData(uniqueData);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (idClient) {
      getProduct();
    }
  }, [nullOptions, idClient]);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder={nullOptions ? "Pilih Client Dahulu" : "Pilih Produk"}
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={
        nullOptions
          ? null
          : listData?.map((e) => ({
              label: e.product_name,
              value: e.product_id,
            }))
      }
    />
  );
};

export default SelectClientProduct;
